// https://stackoverflow.com/questions/38627024/convert-english-numbers-to-persian-farsi
export default function toFarsiNumber(n) {
  const farsiDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];

  return n
    .toString()
    .split('')
    .map(x => farsiDigits[x])
    .join('');
}
